module.exports = __webpack_public_path__ + "static/media/C_F02.af4482c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_F02.png
// module id = 98
// module chunks = 0